import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  continueOnMobileButton: {
    display: 'none',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      display: 'block',
    },
  },
}))

export default useStyles
